export default {
  methods: {
    hasRingSolutionsUrl(device) {
      return (
        device.ring_solutions_url &&
        device.ring_solutions_url.startsWith("http") &&
        !device.ring_solutions_url_unavailable
      );
    },
    hasRingSolutionsUnavailable(device) {
      return (
        device.ring_solutions_url &&
        device.ring_solutions_url.startsWith("http") &&
        device.ring_solutions_url_unavailable
      );
    },
    getRingSolutionsUrlUnavailableDescription(reason) {
      if (reason == "NOT_AVAILABLE_FOR_RBAC_VIEWER_ROLE") {
        return "Viewers do not have access to Alarm information";
      }
      return "";
    },
  },
};
